<template>
  <div class="main-container">
    <bsp-tabs :tabList="tabList" :tabIndex="tabIndex" @changeTab="changeTab">
      <div class="table-operations" slot="ope">
        <el-button type="primary" @click="createCost">{{$t('cost.cost001')}}</el-button><!-- 填写付款单 -->
      </div>
<!--      <bsp-grid-->
<!--        class="bsp-grid"-->
<!--        ref="itemListTable"-->
<!--        :demoLoading.sync="demoLoading"-->
<!--        :tableColumns.sync="tableColumns"-->
<!--        :tableDatas.sync="tableDatas"-->
<!--        @tableRefresh="tableRefresh"-->
<!--        @updateColumn="updateColumn"-->
<!--        @checkbox-all="selectAllEvent"-->
<!--        @checkbox-change="selectChangeEvent"-->
<!--        :pagerConfig="pagerConfig"-->
<!--        :checkbox-config="{ checkMethod: checkboxMethod, highlight: true, range: true}"-->
<!--      >-->
<!--        <template v-slot:discernCusIdText="{row}">-->
<!--          <el-link type="primary" @click="toEditPage(row, 'view')" style = "text-overflow: ellipsis;white-space: nowrap;display:block;overflow: hidden;" >{{ row.cusName }}</el-link>-->
<!--          &lt;!&ndash;        <span>{{ discernCusMap[row.cusId]}}</span>&ndash;&gt;-->
<!--        </template>-->
<!--        <template v-slot:discernStatusText="{row}">-->
<!--          <span>{{ dicts.codeMap[row.status]}}</span>-->
<!--        </template>-->

<!--        <template v-slot:discernTdStatusText="{row}">-->
<!--          <span>{{ row.isPause == "00901" ? "挂起" : dicts.codeMap[row.tdStatus]}}{{ (row.tdStatus == '80440003' || row.tdStatus == '80440007') ? '(' + row.tdRn + ')' : '' }}</span>-->
<!--        </template>-->

<!--        <template v-slot:sup="{row}">-->
<!--          <span>{{ row.sup == "00901" ? "是" : "否"}}</span>-->
<!--        </template>-->

<!--        <template v-slot:operation="{row}">-->

<!--          <el-image class="gridOptIcon" :src="viewIconUrl" title="查看报销明细" @click="viewCost(row.id, row)" ></el-image>-->
<!--          <el-image class="gridOptIcon" v-show="initCostStatus=='30300020' || initCostStatus=='30300021' || initCostStatus=='30300001'" :src="eidtIconUrl" title="修改报销单" @click="editCost(row.id, row)" ></el-image>-->
<!--          <el-image class="gridOptIcon" v-show="initCostStatus=='30300020' || initCostStatus=='30300021' || initCostStatus=='30300001'" :src="deleteIconUrl" title="删除报销单" @click="deleteCost(row.id, row)" ></el-image>-->
<!--          <el-image class="gridOptIcon" v-show="initCostStatus=='30300010' || initCostStatus=='30300030'" :src="showIconUrl" title="查看报销单" @click="printCost(row.id, row)" ></el-image>-->
<!--          <el-image class="gridOptIcon" v-show="initCostStatus=='30300005' || initCostStatus=='30300010'" :src="withdrawIconUrl" title="撤回" @click="withdrawCost(row.id, row)" ></el-image>-->

<!--          &lt;!&ndash; 查看报销明细    all &ndash;&gt;-->
<!--          &lt;!&ndash; 修改报销单    驳回 撤回 草稿 &ndash;&gt;-->
<!--          &lt;!&ndash; 删除报销单    驳回 撤回 草稿  &ndash;&gt;-->
<!--          &lt;!&ndash; 查看报销单    财务审核 结束 &ndash;&gt;-->
<!--          &lt;!&ndash; 撤回    领导审核 财务审核 &ndash;&gt;-->
<!--        </template>-->
<!--      </bsp-grid>-->

      <bsp-table
        class="bsp-grid"
        ref="invoiceListTable"
        v-loading="demoLoading"
        :data.sync="tableDatas"
        :element-loading-text="$t('homepage.txt029')"
        :ciic-data-filter.sync="listQuery"
        @ciic-data-refresh="ciicDataRefresh"
        @ciic-data-select="ciicDataSelect"
        element-loading-spinner="el-icon-loading"
        show-header-overflow
        show-overflow
      ><!-- 拼命加载中 -->
        <vxe-table-column type="checkbox" width="50" fixed="left" align="center"></vxe-table-column>

        <bsp-table-column field="applierDate" :title="$t('cost.cost002')" align="center" :slot-filter="true" filter-type="input" ><!-- 申请日期 -->
          <template slot-scope="scope">
            <span>{{ scope.row.applierDate }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="costTypeName" :title="$t('cost.cost003')" align="center" :slot-filter="true" filter-type="input" ><!-- 报销类型 -->
          <template slot-scope="scope">
            <span>{{ scope.row.costTypeName }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="createPerName" :title="$t('cost.cost004')" align="center" :slot-filter="true" filter-type="input" ><!-- 申请人 -->
          <template slot-scope="scope">
            <span>{{ scope.row.createPerName }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="payeeName" :title="$t('cost.cost005')" align="center" :slot-filter="true" filter-type="input" ><!-- 收款人 -->
          <template slot-scope="scope">
            <span>{{ scope.row.payeeName}}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="payMoney" :title="$t('cost.cost006')" align="center" :slot-filter="true" filter-type="input" ><!-- 付款金额 -->
          <template slot-scope="scope">
            <span>{{ scope.row.payMoney | moneyFilterRMB }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="totalMoney" :title="$t('cost.cost007')" align="center" :slot-filter="true" filter-type="input" ><!-- 总金额 -->
          <template slot-scope="scope">
            <span>{{ scope.row.totalMoney | moneyFilterRMB }}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="remark" :title="$t('cost.cost008')" align="center" :slot-filter="true" filter-type="input" ><!-- 报销原因 -->
          <template slot-scope="scope">
            <span>{{ scope.row.remark}}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="currentLink" :title="$t('cost.cost009')" align="center" :slot-filter="true" filter-type="input" v-if="initCostStatus == '30300005' || initCostStatus == '30300010'"><!-- 当前环节 -->
          <template slot-scope="scope">
            <span>{{ scope.row.currentLink}}</span>
          </template>
        </bsp-table-column>

        <bsp-table-column field="backReason" :title="initCostStatus == '30300020'? $t('cost.cost010') : $t('cost.cost011') " v-if="initCostStatus == '30300020' || initCostStatus == '30300021'" align="center" :slot-filter="true" filter-type="input" ><!-- 驳回原因 撤回原因 -->
          <template slot-scope="scope">
            <span>{{ scope.row.backReason}}</span>
          </template>
        </bsp-table-column>

<!--        <vxe-table-column field="status" title="发票状态" align="center" :filters="[{ data: '' }]"  >-->
<!--          <template #filter="{ $panel, column }">-->
<!--            <el-select clearable  filterable v-model="column.filters[0].data" @change="changeStatusFilter($event)" size="medium" @clear="clearData">-->
<!--              <el-option v-for="(item) in templateStatusList" :key="item.id" :value="item.id" :label="item.name"></el-option>-->
<!--            </el-select>-->
<!--          </template>-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ dicts.codeMap[scope.row.status]  }}</span>-->
<!--          </template>-->
<!--        </vxe-table-column>-->

        <vxe-table-column field="sup" :title="$t('cost.cost012')" align="center" :filters="[{ data: '' }]" v-if="initCostStatus == '30300030'"  ><!-- 是否待补充 -->
          <template #filter="{ $panel, column }">
            <el-select clearable  filterable v-model="column.filters[0].data" @change="changeSupFilter($event)" size="medium" @clear="clearData">
              <el-option v-for="(item) in templateSupList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.sup == "00901" ? $t('homepage.txt030') : $t('homepage.txt031') }}</span><!-- 是 否 -->
          </template>
        </vxe-table-column>

        <bsp-table-column field="operation" :title="$t('cost.invoice013')" align="center" minWidth='60px'><!-- 操作 -->
          <template slot-scope="scope">
            <el-image class="gridOptIcon" :src="viewIconUrl" :title="$t('cost.cost013')" @click="viewCost(scope.row.id, scope.row)" ></el-image><!-- 查看报销明细 -->
            <el-image class="gridOptIcon" v-show="initCostStatus=='30300020' || initCostStatus=='30300021' || initCostStatus=='30300001'" :src="eidtIconUrl" :title="$t('cost.cost014')" @click="editCost(scope.row.id, scope.row)" ></el-image><!-- 修改报销单 -->
            <el-image class="gridOptIcon" v-show="initCostStatus=='30300020' || initCostStatus=='30300021' || initCostStatus=='30300001'" :src="deleteIconUrl" :title="$t('cost.cost015')" @click="deleteCost(scope.row.id, scope.row)" ></el-image><!-- 删除报销单 -->
            <el-image class="gridOptIcon" v-show="initCostStatus=='30300010' || initCostStatus=='30300030'" :src="showIconUrl" :title="$t('cost.cost016')" @click="printCost(scope.row.id, scope.row)" ></el-image><!-- 查看报销单 -->
            <el-image class="gridOptIcon" v-show="initCostStatus=='30300005' || initCostStatus=='30300010'" :src="withdrawIconUrl" :title="$t('cost.cost017')" @click="withdrawCost(scope.row.id, scope.row)" ></el-image><!-- 撤回 -->

          </template>
        </bsp-table-column>

      </bsp-table>

    </bsp-tabs>
    <opt-cost ref="optCost" @reload="doOptCostSubmit"></opt-cost>
  </div>
</template>

<script>
  import bspTabs from "@/components/bsp/bsp-tabs/bsp-tabs-v2"
  import bspGrid from "@/components/bsp/bsp-grid/grid";
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import OptCost from "@/views/cost/components/OptCost"
  import viewIcon from '@/assets/img/miniuiIcon/search_2.gif'
  import eidtIcon from '@/assets/img/miniuiIcon/edit_on.gif'
  import deleteIcon from '@/assets/img/miniuiIcon/delete_on.gif'
  import showIcon from '@/assets/img/miniuiIcon/view_bill.gif'
  import withdrawIcon from '@/assets/img/miniuiIcon/withdraw.png'
  import { getCloudCostStatusList, deleteCloudCostInfo } from "@/api/cost/cost";
  import { downloadFile, formatRmb } from '@/util/util'
  import { base64Encode } from "@/util/endecode";
  import { mapGetters } from 'vuex';

  export default {
    name: "costList",
    components: { bspTabs, bspGrid , bspTable,bspTableColumn, OptCost},
    data() {
      return {
        tabList: [
          { title: this.$t('cost.cost018'), name: 'leaderApply' },//待领导审批
          { title: this.$t('cost.cost019'), name: 'finApply' },//待财务审批
          { title: this.$t('cost.cost020'), name: 'rejected' },//已驳回
          { title: this.$t('cost.cost021'), name: 'withdraw' },//已撤回
          { title: this.$t('cost.cost022'), name: 'draft' },//草稿
          { title: this.$t('cost.cost023'), name: 'payFinish' }//已付款
        ],
        tabIndex: 'leaderApply',
        currentTab: 'leaderApply',
        searchForm:{},
        searchParams: {},
        tableDatas: [],
        tableColumns: [],
        // filtersData: { page: 1, limit: 20 },
        // pagerConfig: {
        //   total: 0,
        //   page: 1,
        //   limit: 20
        // },
        listQuery:{
          limit: 20,
          page: 1,
          total: 0,
          filters: []
        },
        demoLoading: true,
        loadingImport: false,
        loadingBtn: false,
        multipleSelection: [],
        initCostStatus: "30300005",
        viewIconUrl : viewIcon,
        eidtIconUrl : eidtIcon,
        deleteIconUrl : deleteIcon,
        showIconUrl : showIcon,
        withdrawIconUrl : withdrawIcon,
        preUrl: process.env.VUE_APP_ACCOUNT_CLOUD_BASE_URL,
        templateSupList: [
          {id:"00900", name: this.$t('homepage.txt031')},
          {id:"00901", name: this.$t('homepage.txt030')},
        ]
      };
    },
    created() {
      if(this.$route.query.currentTab){
        this.tabIndex = this.$route.query.currentTab;
        this.currentTab = this.$route.query.currentTab;

        switch (this.$route.query.currentTab) {
          case 'leaderApply':
            this.initCostStatus = "30300005";
            break;
          case 'finApply':
            this.initCostStatus = "30300010";
            break;
          case 'rejected':
            this.initCostStatus = "30300020";
            break;
          case 'withdraw':
            this.initCostStatus = "30300021";
            break;
          case 'draft':
            this.initCostStatus = "30300001";
            break;
          case 'payFinish':
            this.initCostStatus = "30300030";
            break;
        }

      }
      let lang = localStorage.getItem("lang") || 'zh';
      this.parmStr = "lang=" + base64Encode(lang) + "&accessToken=" + this.$store.getters.accessToken + "&aacode=invoice";
      this.getColumn();
      this.init();
    },
    watch: {
      currentTab: function (newVal, oldVal) {
        switch (newVal) {
          case 'leaderApply':
            this.initCostStatus = "30300005";
            break;
          case 'finApply':
            this.initCostStatus = "30300010";
            break;
          case 'rejected':
            this.initCostStatus = "30300020";
            break;
          case 'withdraw':
            this.initCostStatus = "30300021";
            break;
          case 'draft':
            this.initCostStatus = "30300001";
            break;
          case 'payFinish':
            this.initCostStatus = "30300030";
            break;
        }
        this.getColumn();
        this.init();
        console.log("currentTab Watch", newVal)
      }
    },
    methods: {
      // 导出
      exportExcel() {
        this.demoLoading = true;
        var tdStatusArr = this.searchForm.tdStatusArr;
        var tdStatus = "";
        if(tdStatusArr != null && tdStatusArr.length > 0){
          for(var i = 0; i < tdStatusArr.length; i++){
            tdStatus += tdStatusArr[i] + ",";
          }
        }

        let params = {
          ...this.listQuery,
          searchParams : {
            tdStatus : tdStatus,
            cusId : this.searchForm.cusId,
            appliId : this.searchForm.appliId,
            handlerId : this.searchForm.handlerId,
            startEndDate : this.searchForm.startDate,
            endEndDate : this.searchForm.endDate,
            userTdRole : this.userTdRole,
            startCompleteDate: this.searchForm.startCompleteDate,
            endCompleteDate: this.searchForm.endCompleteDate,
            felId : this.searchForm.felId,
            tdType: this.searchForm.tdType,
            accountMonth: this.searchForm.accountMonth
          }
        }
        // exportTaskList(params)
        //   .then((res) => {
        //     if (res.headers['content-disposition'] === undefined) {
        //       this.demoLoading = false
        //       this.$message.error('账单下载失败,请联系运维人员！')
        //     } else {
        //       downloadFile(res)
        //       this.demoLoading = false
        //       this.$message.success("下载成功！");
        //     }
        //   })
      },
      // 查询
      handleSearch() {
        // this.pagerConfig.page = 1;
        // this.filtersData.page = 1;
        this.listQuery.page = 1;
        this.searchParams = this.searchForm;
        this.getData();
      },
      handleReset() {
        this.searchForm = {};
        this.initSelectForm();
        // this.pagerConfig.page = 1;
        // this.filtersData.page = 1;
        this.listQuery.page = 1;
        this.searchParams = this.searchForm;
        this.getData();
      },
      changeTab(tab) {
        this.listQuery = {
          limit: 20,
          page: 1,
          total: 0,
          filters: []
        };
        this.currentTab = tab.name;
      },
      changeSupFilter(e){
        if (e) {
          this.listQuery['filters'] =  [{operator: "=", column: "sup", value:e}]
          this.listQuery.page = 1;
          this.getData();
        }
      },
      clearData() {
        this.listQuery.filters = [];
        this.listQuery.page = 1;
        this.getData();
      },
      // 获取表头
      getColumn() {
        let column = [
          {
            type: "checkbox",
            setId: "",
            width: 50,
          },{
            type: "",
            field: "applierDate",
            title: "申请日期",
            titlePrefix: {
              content: '&'
            }
            //visible: false
          },{
            type: "",
            field: "costTypeName",
            title: "报销类型",
          },{
            type: "",
            field: "createPerName",
            title: "申请人",
          },{
            type: "",
            field: "payeeName",
            title: "收款人",
          },{
            type: "",
            field: "payMoney",
            title: "付款金额",
            formatter: formatRmb,
          },{
            type: "",
            field: "totalMoney",
            title: "总金额",
            formatter: formatRmb,
          },{
            type: "",
            field: "remark",
            title: "报销原因",
          },{
            type: "",
            field: "currentLink",
            title: "当前环节",//待领导 待财务环节
            visible: this.initCostStatus == '30300005' || this.initCostStatus == '30300010'
          },{
            type: "",
            field: "backReason",
            title: "驳回原因",//驳回环节特有
            visible: this.initCostStatus == '30300020'
          },{
            type: "",
            field: "backReason",
            title: "撤回原因",//撤回环节特有
            visible: this.initCostStatus == '30300021'
          },{
            type: "",
            field: "sup",
            title: "是否待补充", //完成环节
            visible: this.initCostStatus == '30300030',
            params:{slot:'sup'}
          },{
            type: "",
            field: "",
            title: "操作",
            minWidth : '60px',
            params:{slot:'operation'}
            //params:{slot:'discernShelvedFlagText'}
          }
        ];
        this.$set(this,"tableColumns",column);
      },
      init() {
        // if(this.$route.query.from){
        //   alert(this.$route.query.tdStatus);
        // }
        // var user = this.$store.state.user.userInfo;
        // this.userId = user.userId;
        this.getData();
      },
      createCost(){
        var optParam = {
          costId : '',
          editFlag : 'add'
        };
        //console.log("toEditpage");
        //console.log(this.optParam);
        this.$router.push({path:'/costApplication/costEdit',query: optParam});
      },
      editCost(id, costBO){
        var optParam = {
          costId : costBO.id,
          editFlag : 'edit',
          costStatus : costBO.costStatus,
          costType : costBO.costType,
        };
        //console.log("toEditpage");
        //console.log(this.optParam);
        this.$router.push({path:'/costApplication/costEdit',query: optParam});
      },
      viewCost(id, costBO){
        var optParam = {
          costId : costBO.id,
          editFlag : 'view',
          costStatus : costBO.costStatus,
        };
        //console.log("toEditpage");
        //console.log(this.optParam);
        this.$router.push({path:'/costApplication/costEdit',query: optParam});
      },
      deleteCost(id, costBO){

        var that = this;
        this.$confirm(
          '是否确认删除报销单！',
          '提示',
          {
            type: 'warning'
          }
        ).then(function(){
          //确认操作
          var params = {
            mainForm : {costId : id}
          };

          deleteCloudCostInfo(params)
            .then((response) => {
              that.demoLoading = false;
              let result = response.data;
              if(result.code == '0'){
                that.$message.success(that.$t('homepage.txt028')); //操作成功
                that.getData();
              }else{
                that.$message.success(result.msg);
              }
            })
            .catch(error => {
              that.demoLoading = false;
              console.log("error", error)
              that.$message.error(that.$t('homepage.txt024'));//请求异常！
            });
        }).then((data) => {
          //取消操作
        }).catch(function (err) {
          //捕获异常
        });
      },
      printCost(id, costBO){
        var url = this.preUrl + "/cost/costAction_toChooseCostAttachment.action?costId=" + base64Encode(id) + "&" + this.parmStr;
        window.open(url, '_blank')
      },
      withdrawCost(id, costBO){
        let params = {
          costId : id,
          flag : "BXDCH",
        }
        this.$refs.optCost.visible = true;
        this.$refs.optCost.optParams = params;
        this.$refs.optCost.init();
      },
      doOptCostSubmit(){
        this.getData();
      },
      viewTaskCnt(){
        this.optParam = {
          tdId: null,
          optType: 'add',
          tdStatus: null,
          userTdRole: this.userTdRole,
          userId: this.userId,
          from: "taskList"
        };
        this.$router.push({path:'/taskDispatch/glCusList'});
      },
      //============================================================
      // 获取数据
      getData() {
        this.demoLoading = true;
        var tdStatusArr = this.searchForm.tdStatusArr;
        var tdStatus = "";
        if(tdStatusArr != null && tdStatusArr.length > 0){
          for(var i = 0; i < tdStatusArr.length; i++){
            tdStatus += tdStatusArr[i] + ",";
          }
        }
        let params = {
          ...this.listQuery,
          searchParams : {
            costStatus: this.initCostStatus,
          }
        }
        getCloudCostStatusList(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.tableDatas = result.data.records;
            this.listQuery.total = result.data.total;

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

      },
      //bsp-table分页筛选
      ciicDataRefresh() {
        console.log("ciicDataRefresh-listQuery", this.listQuery)
        this.getData();
      },
      ciicDataSelect(data){
        console.log("ciicDataSelect", data)
        this.multipleSelection = data;
      },
      //获取请求筛选数据/分页
      tableRefresh(filter, cal) {
        // this.filtersData = filter;
        // this.pagerConfig.page = filter.page;
        // this.pagerConfig.limit = filter.limit;
        this.getData(cal);
      },
      updateColumn(columns) {
        //console.log(columns);
      },
      selectAllEvent({ checked, records, selection }) {
        this.multipleSelection = records;
      },
      selectChangeEvent({ checked, records }) {
        this.multipleSelection = records;
      },
      // 禁用表格复选框
      checkboxMethod({row}) {
        return true;
        //return row.discernStatus == '80130003';
      },
      toStorageDetailLevel2(itemId){
        this.optParam = {
          itemId: itemId,
          storageId: this.storageId,
          storageName: this.storageName,
        };
        this.$refs.storageDetailLevel2.visible = true;
        this.$refs.storageDetailLevel2.optParam = this.optParam;
        this.$refs.storageDetailLevel2.init();
      },
      toBatchDetail(itemId,itemCode){
        this.optParam = {
          itemId: itemId,
          itemCode: itemCode,
          storageId: this.storageId,
          storageName: this.storageName,
          from: "storageDetailList"
        };
        this.$router.push({path:'/inventory/batchDetailList',query:this.optParam});
      },
      toInbound(){
        this.optParam = {
          storageId: this.storageId,
          storageName: this.storageName,
          from: "storageDetailList",
        };
        this.$router.push({path:'/inventory/batchInbound',query:this.optParam});
      },
      toOutbound(){
        this.optParam = {
          storageId: this.storageId,
          storageName: this.storageName,
          from: "storageDetailList"
        };
        this.$router.push({path:'/inventory/batchOutbound',query:this.optParam});
      },
      isNotBlank(str){
        if(str == null || str ==undefined || str == ''){
          return false;
        }else{
          return true;
        }
      }
    },
    computed: {
      ...mapGetters(['billBatch','userInfo','dicts']),
    }
  };
</script>
